import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { ChevronDownIcon, ChevronUpIcon } from '../../assets';
import { theme } from '../../theme';
import { UIText } from '../typography';
import { BaseAccordion } from './BaseAccordion';
import { AccordionSize } from './types';

export type AccordionIconRightProps = {
  open: boolean;
  size: AccordionSize;
  title: string;
  toggleOpen: () => void;
  className?: string;
  dataTestid?: string;
};

const Wrapper = styled.div`
  border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[7]};
`;

const Header = styled.div<{ size: AccordionSize }>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${({ size }) => theme.spacings[size === 'sm' ? 2 : 4].rem}
    ${theme.spacings[4].rem};
`;

const IconStyles = css`
  fill: ${theme.colors.primary.graysGray};
  width: 12px;
`;

const ChevronDown = styled(ChevronDownIcon)`
  ${IconStyles}
`;

const ChevronUp = styled(ChevronUpIcon)`
  ${IconStyles}
`;

const Title = styled(UIText)`
  color: ${theme.colors.neutrals.solidGrays[2]};
  font-weight: 700;
`;

const Content = styled.div`
  padding: ${theme.spacings[2].rem} ${theme.spacings[4].rem};
`;

const Divider = styled.hr`
  border: none;
  margin: 0;
  width: 100%;
`;

export const AccordionIconRight: React.FC<
  PropsWithChildren<AccordionIconRightProps>
> = ({ children, open, size, title, toggleOpen, className, dataTestid }) => (
  <Wrapper className={className} data-testid={dataTestid}>
    <BaseAccordion
      header={
        <Header size={size}>
          <Title size={size}>{title}</Title>
          {open ? <ChevronUp /> : <ChevronDown />}
        </Header>
      }
      onToggleOpen={toggleOpen}
      open={open}
    >
      <Content>{children}</Content>
    </BaseAccordion>
    <Divider />
  </Wrapper>
);
